import React, { memo, useEffect, useRef } from 'react';
import { createSlider } from '@typeform/embed';
import { Button } from '@farmers-fridge/ui-library';
import { getIcon } from '../iconMap';
import getIdFromUrl from './getIdFromEmbedUrl';
import '@typeform/embed/build/css/slider.css';
import styles from './Slider.module.css';

/** @param {FF.ContentfulTypeform} props */
function Slider({ buttonIcon, buttonText, buttonType, formEmbedUrl }) {
  /**  @type {React.MutableRefObject<HTMLDivElement|null>} errorMsgRef */
  const container = useRef(null);
  useEffect(() => {
    if (container.current) {
      const ref = createSlider(getIdFromUrl(formEmbedUrl));
      const buttonEl = container.current.querySelector('button');
      const buttonEventHandler = () => {
        ref.toggle();
      };
      buttonEl?.addEventListener('click', buttonEventHandler);

      return () => {
        ref.unmount();
        buttonEl?.removeEventListener('click', buttonEventHandler);
      };
    }
    return () => {};
  }, []);

  return (
    <div ref={container}>
      <Button
        className={styles.button}
        // @ts-ignore
        buttonType={buttonType.toLowerCase()}
        type="button"
      >
        {buttonType !== 'Tertiary' && getIcon(buttonIcon?.name)}
        {buttonText}
      </Button>
    </div>
  );
}

export default memo(Slider);
